import Vue from "vue";
import {$projects} from "@/services/";

const module = {
  namespaced: true,

  state: {
    unit: {
      abbr: "m",
      label: "meter",
    },
    items: [],
    item: {},
    meta: { pagination: {} },
    divaltoUrl: null,
    currentViewer: "2D",
  },

  getters: {
    items: (state) => state.items,
    unit: (state) => state.unit,
    item: (state) => state.item,
    meta: (state) => state.meta,
    scale: (state) => (state.item && state.item.scale) || 1,
    isScaleSet: (state) => state.item && state.item.scale,
    divaltoUrl: (state) => state.item && state.item.estimation_url,
    currentViewer: (state) => state.currentViewer,
  },

  mutations: {
    ITEMS(state, value) {
      value = value.map((item) => {
        item.asset_status = (item.asset && item.asset.status) || "Pending";
        return item;
      });
      state.items = value;
    },

    ITEM(state, value) {
      state.item = value;
    },

    ADD_ITEM(state, value) {
      state.items.push(value);
    },

    META(state, meta) {
      state.meta = meta;
    },

    UPDATE(state, { id, data }) {
      var index = state.items.findIndex((obj) => obj.id == id);
      index > -1 && Vue.set(state.items, index, data);
      if (state.item.id == id) {
        state.item = { ...state.item, ...data };
      }
    },

    DELETE(state, id) {
      let index = state.items.findIndex((i) => i.id == id);
      index > -1 && state.items.splice(index, 1);
    },

    DIVALTO_URL(state, url) {
      state.divaltoUrl = url;
    },

    CHANGE_VIEWER(state, viewerType) {
      state.currentViewer = viewerType;
    },
  },

  actions: {
    all({ commit }, { config }) {
      return $projects.all(config).then(function (res) {
        let { data, meta } = res.data;
        commit("ITEMS", data);
        commit("META", meta);
        return res;
      });
    },

    create({ commit }, { payload, config }) {
      return $projects.create(payload, config).then((res) => {
        commit("ADD_ITEM", res.data);
        return res;
      });
    },

    find({ commit }, { id, config }) {
      return $projects.show(id, config).then((res) => {
        commit("ITEM", res.data.data);
        return res;
      });
    },

    delete({ commit }, { id }) {
      return $projects.delete(id).then(() => {
        commit("DELETE", id);
      });
    },

    update({ commit }, { id, payload, config }) {
      console.log("project update");
      return $projects.update(id, payload, config).then((res) => {
        let { data } = res;
        commit("UPDATE", { id, data });
        return res;
      });
    },

    divaltoUrl({ commit }, { id, config }) {
      return $projects.show(id, config).then((res) => {
        commit("DIVALTO_URL", res.data.data.estimation_url);
        return res.data.data;
      });
    },

    setViewer({ commit }, viewerType) {
      commit("CHANGE_VIEWER", viewerType);
    },

    reportAuthToken({ commit }, { id, config }) {
      return $projects.reportAuthToken(id, config).then((resp) => {
        return resp;
      });
    },

    fetchGroupedEquipments({ commit }, { projectId, params = {} }) {
      return $projects.groupedEquipments(projectId, { params });
    },
  },
};

export default module;